import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  type: "",
  currentStepIndex: 0,
  currentSubstepIndex: 0,
  planChanged: false, // Track if user changed the plan
};

const travelRenewalFlowSlice = createSlice({
  name: "travelRenewalFlow",
  initialState,
  reducers: {
    setTravelRenewalFlowType: (state, action) => {
      state.type = action.payload.type;
      state.currentStepIndex = action.payload.currentStepIndex || 0;
      state.currentSubstepIndex = action.payload.currentSubstepIndex || 0;
    },
    setCurrentStepIndex: (state, action) => {
      state.currentStepIndex = action.payload;
    },
    setCurrentSubstepIndex: (state, action) => {
      state.currentSubstepIndex = action.payload;
    },
    setPlanChanged: (state, action) => {
      state.planChanged = action.payload;
    },
    resetTravelRenewalFlow: (state) => {
      state.type = "";
      state.currentStepIndex = 0;
      state.currentSubstepIndex = 0;
      state.planChanged = false;
    },
  },
});

export const {
  setTravelRenewalFlowType,
  setCurrentStepIndex,
  setCurrentSubstepIndex,
  setPlanChanged,
  resetTravelRenewalFlow,
} = travelRenewalFlowSlice.actions;

export const selectTravelRenewalFlowType = (state) =>
  state.travelRenewalFlow.type;
export const selectCurrentStepIndex = (state) =>
  state.travelRenewalFlow.currentStepIndex;
export const selectCurrentSubstepIndex = (state) =>
  state.travelRenewalFlow.currentSubstepIndex;
export const selectPlanChanged = (state) =>
  state.travelRenewalFlow.planChanged;

export default travelRenewalFlowSlice.reducer;
